import { AdddCircleIcon } from '@mybridge/icons';
import { useDisclosure } from '@mybridge/ui/hooks';
import { Input, InputGroup, InputRightElement } from '@mybridge/ui/input';
import { HStack } from '@mybridge/ui/layout';
import { List, ListItem } from '@mybridge/ui/list';
import {
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@mybridge/ui/popover';
import { Spinner } from '@mybridge/ui/spinner';
import { Text } from '@mybridge/ui/text';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useUniversities } from 'v4/lib/hooks/use-universities';
import { useOutsideClick } from '@mybridge/ui/hooks';
import { CustomDropdown } from '../custom-dropdown';

export const UniversitiesDropdown = ({ ...props }) => {
  const [search, setSearch] = useState();

  const { data, createLoading, mutateAsync, isLoading } = useUniversities({
    search,
  });

  const universities = useMemo(
    () => data?.pages?.reduceRight?.((ac, p) => ac.concat(p?.results), []),
    [data?.pages]
  );

  return (
    <CustomDropdown
      {...props}
      data={universities}
      isLoading={isLoading}
      onSearch={(s) => setSearch(s)}
    />
  );
};
